import { Theme, css } from '@emotion/react';

export const button = ({ spacing }: Theme) => css`
  padding-left: ${spacing(1.5)}px !important;
  padding-right: ${spacing(1.5)}px !important;
`;

// The last time item in a row gets extra right padding, unless it is the 3rd
// item (a full row of exactly three). All siblings are same-type wrapper divs,
// so :nth-of-type / :last-of-type match the same elements as the original
// :nth-child / :last-child while remaining SSR-safe for Emotion.
const timeItemLastChildButNotThirdChild = ({ spacing }: Theme) => css`
  &:not(:nth-of-type(3)):last-of-type {
    box-sizing: content-box;
    padding-right: ${spacing(3)}px;
  }
`;

export const timeItem = (theme: Theme) => {
  const { breakpoints, spacing, typography } = theme;

  return css`
    flex: 1 0 auto;
    margin-right: ${spacing(1)}px;
    max-width: ${typography.pxToRem(120)};
    ${timeItemLastChildButNotThirdChild(theme)};
    ${breakpoints.up('md')} {
      padding-left: ${spacing(2)}px;
      padding-right: ${spacing(2)}px;
    }
  `;
};

export const simpleTimeItem = (theme: Theme) => {
  const { breakpoints, spacing } = theme;
  // Mss stands for "minus some spacing"
  const oneThirdMss = `calc(33.3333% - ${spacing(0.5)}px)`;
  const oneFourthMss = `calc(25% - ${spacing(0.5)}px)`;

  return css`
    flex: 0 0 ${oneThirdMss};
    max-width: ${oneThirdMss};
    margin-right: ${spacing(0.5)}px;
    margin-left: 0 !important;
    ${timeItemLastChildButNotThirdChild(theme)};
    ${breakpoints.up('md')} {
      flex: 0 0 ${oneFourthMss};
      max-width: ${oneFourthMss};
    }
  `;
};

export const priceTypography = css`
  margin-top: 2px;
  text-align: center;
`;
